import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { HSNSummary, HSNSummaryCreate, HSNSummaryFilter } from '../data/hSNSummary';

export function createHSNSummaryService(client: AxiosInstance) {
  return createCrudService<HSNSummary, HSNSummaryCreate, HSNSummaryFilter>(
    client,
    '/accounting/HSNSummary',
    'id',
  );
}

export type HSNSummaryService = CrudService<HSNSummary, HSNSummaryCreate, HSNSummaryFilter>;
